// new discount-aanouncement bar
// =============== home page copy code js
const codecopy = document.querySelector(".copy-code-right");
const closeicons = document.querySelector(".discount-bar-close-icon");
const mainClass = document.querySelector(".coupan-code");
if (codecopy) {
  codecopy.addEventListener("click", function () {
    let copyText = document.querySelector(".copy-code-left").innerText;

    let tempTextArea = document.createElement("textarea");
    tempTextArea.value = copyText;
    document.body.appendChild(tempTextArea);
    tempTextArea.select();
    document.execCommand("copy");
    document.body.removeChild(tempTextArea);
    alert("Code erfolgreich kopiert");
  });
}
closeicons.addEventListener("click", function () {
  mainClass.classList.remove("close-bar");
});

document.addEventListener("DOMContentLoaded", function () {
  var wrapperEl = document.querySelector(".testimonial-box-wrapper");

  if (!wrapperEl) {
    console.error("testimonial-box-wrapper not found");
    return;
  }

  var testi_flkty = new Flickity(wrapperEl, {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: false,
    autoPlay: false,
    adaptiveHeight: true,
    wrapAround: true
  });

  var prevBtn = document.querySelector('.slider-button--previous');
  var nextBtn = document.querySelector('.slider-button--next');

  document.addEventListener('click', function (event) {
    if (event.target.closest('.slider-button--next')) {
      testi_flkty.next();
    }

    if (event.target.closest('.slider-button--previous')) {
      testi_flkty.previous();
    }
  });

});



let footer_flkty;
let icon_flkty;
function checkAndInitFlickity() {
  if (window.innerWidth < 851) {
    if (!footer_flkty) {
      footer_flkty = new Flickity(".footer-icon-with-text_slider", {
        cellAlign: "left",
        contain: true,
        prevNextButtons: true,
        pageDots: false,
         autoPlay: false,
        wrapAround: true,
        draggable: true
      });
    }
  } else {
    if (footer_flkty) {
      footer_flkty.destroy();
      footer_flkty = null;
    }
  }

    var footer_prevBtn = document.querySelector('.footer-button--previous');
    var footer_nextBtn = document.querySelector('.footer-button--next');

    document.addEventListener('click', function (event) {
      if (event.target.closest('.footer-button--next')) {
        footer_flkty.next();
      }

      if (event.target.closest('.footer-button--previous')) {
        footer_flkty.previous();
      }
    });

  // if (window.innerWidth < 1140) {
  //   if (!icon_flkty) {
  //     icon_flkty = new Flickity(".footer-icon-with-text_slider", {
  //       cellAlign: "left",
  //       contain: true,
  //       prevNextButtons: true,
  //       pageDots: false,
  //       draggable: false
  //     });
  //   }
  // } else {
  //   if (icon_flkty) {
  //     icon_flkty.destroy();
  //     icon_flkty = null;
  //   }
  // }
}
checkAndInitFlickity();
window.addEventListener("resize", checkAndInitFlickity);

// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      const isOpen = accordion.classList.contains("is-open");
      document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
        item.classList.remove("is-open");
        const content = item.nextElementSibling;
        if (content) content.style.maxHeight = "0px";
      });
      if (!isOpen) {
        accordion.classList.add("is-open");
        const content = accordion.nextElementSibling;
        if (content) content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

// -------------- faq page  js
const faqtitle = document.querySelectorAll('.faq-btn');
faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    console.log(gettitle, "gettitle");
    faqtitle.forEach(btn => btn.classList.remove('active')); // Remove from all buttons
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);
    console.log(contentdiv, 'contentdiv');

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
    classremove.classList.remove('dropdown-active')
  });
});

document.querySelectorAll('.dropdown-button').forEach(dropdownBtn => {
  dropdownBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevents immediate closing when clicking button

    const closestDiv = this.closest('.dropdown');
    const dropdownContent = closestDiv.querySelector('.dropdown-content');

    // Close all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(content => {
      if (content !== dropdownContent) {
        content.classList.remove('dropdown-active');
      }
    });

    dropdownContent.classList.toggle('dropdown-active');
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.dropdown-content').forEach(content => {
    if (!content.closest('.dropdown').contains(event.target)) {
      content.classList.remove('dropdown-active');
    }
  });
});
function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("dropdownIcon");
  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}

const radios = document.querySelectorAll('.pack-radio');
const quantityField = document.querySelector('[custom-quantity-field]');

radios.forEach(function (radio) {
  radio.addEventListener('change', function () {
    const selectedQty = this.value;

    // Set value in custom input
    if (quantityField) {
      quantityField.value = selectedQty;
    }

    // Optional: Update selected card style
    document.querySelectorAll('[data-product-url]').forEach(card => card.classList.remove('selected'));
    this.closest('[data-product-url]').classList.add('selected');
  });

  // Set initial value if already checked
  if (radio.checked && quantityField) {
    quantityField.value = radio.value;
    radio.closest('[data-product-url]').classList.add('selected');
  }
});

document.addEventListener("DOMContentLoaded", function () {

  function updateQtyFromVariant() {
    const selectedVariantEl = document.querySelector('[data-min][checked], [data-min].is-active, select[data-min] option:checked');
    const qtyInput = document.querySelector('input[name="quantity"]');

    if (selectedVariantEl && qtyInput) {
      const minQty = parseInt(selectedVariantEl.getAttribute("data-min")) || 1;
      qtyInput.min = minQty;
      qtyInput.value = minQty;
    }
  }

  // Run once on load
  updateQtyFromVariant();

  // Watch for changes in product form (Be Yours replaces this after variant change)
  const formEl = document.querySelector('form[action*="/cart/add"]');
  if (formEl) {
    const observer = new MutationObserver(() => {
      updateQtyFromVariant();
    });
    observer.observe(formEl, { childList: true, subtree: true });
  }

  // Also hook into Be Yours variant change event (if it exists)
  document.addEventListener("variant:changed", updateQtyFromVariant);

  // Enforce min on add to cart
  document.addEventListener("submit", function (e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      const qtyInput = e.target.querySelector('input[name="quantity"]');
      if (qtyInput) {
        const minQty = parseInt(qtyInput.min) || 1;
        if (parseInt(qtyInput.value) < minQty) {
          qtyInput.value = minQty;
        }
      }
    }
  });
});
